import React, { Component } from 'react';
import OriginPopconfirm from 'bee-popconfirm';
import { getLangCode, getMultiLang, getSysFieldid } from '@platform/api';
import Button from '../Button';
import HotKeys from '../HotKeys';
import Tooltip from '../Tooltip';

require('bee-popconfirm/build/Popconfirm.css');
require('./index.less');

const langCode = getLangCode();
export default class Popconfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            LangData: null,
        };
    }

    content = (
        <span>
            <span className="iconfont icon-tixing" /> &nbsp;您确认删除此业务吗？
        </span>
    );

    componentWillMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'container_toast', callback });
    }

    render() {
        let { json } = this.state;
        let confirm = json['0005'] || '确定';
        let cancel = json['0006'] || '取消';
        return (
            <HotKeys
                keyMap={{
                    sureBtnHandler: [HotKeys.USUAL_KEYS.MODAL_CONFIRM[0], 'enter'],
                    cancelBtnHandler: HotKeys.USUAL_KEYS.MODAL_CALCEL,
                }}
                handlers={{
                    sureBtnHandler: e => {
                        // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                        let confirm = this.Popconfirm || this;
                        if (confirm.state.show) {
                            confirm.handleClose(e);
                        }
                    },
                    cancelBtnHandler: e => {
                        // 取消按钮的事件  增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                        let confirm = this.Popconfirm || this;
                        if (confirm.state.show) {
                            confirm.handleCancel(e);
                        }
                    },
                }}
                className="popconfirm-hotkeys-wrapper "
                display="inline"
                focused={true}
            // attach={false}
            >
                <OriginPopconfirm
                    content={this.content}
                    rootClose={true}
                    // 增加ref对象 用于父调用子方法 bbqin
                    ref={popconfirm => (this.Popconfirm = popconfirm)}
                    {...this.props}
                    fieldid={getSysFieldid("tips-window")}
                    className={`nc-popconfirm ${this.props.className}`}
                    stopbubble={1}
                    locale={{
                        lang: langCode,
                        ok: confirm,
                        cancel,
                    }}
                    cancel_btn={
                        <Button
                            size="sm"
                            style={{ minWidth: 50 }}
                            shape="border" // border  info
                            fieldid="cancel"
                        >
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${cancel}  (${HotKeys.USUAL_KEYS.MODAL_CALCEL})`}
                                trigger={['hover', 'focus']}
                                className="model-helper-overlay"
                            >
                                <span>
                                    {cancel}(
	                                <span className="text-decoration-underline">N</span>
									)
	                            </span>
                            </Tooltip>
                        </Button>
                    }
                    close_btn={
                        <Button size="sm" style={{ minWidth: 50 }} colors="primary" fieldid="confirm">
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${confirm}  (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                                trigger={['hover', 'focus']}
                                className="model-helper-overlay"
                            >
                                <span>
                                    {confirm}(
	                                <span className="text-decoration-underline">Y</span>
									)
	                            </span>
                            </Tooltip>
                        </Button>
                    }
                />
            </HotKeys>
        );
    }
}
